export enum DataSourceInputType {
  Api = "Api",
  Csv = "Csv",
  Custom = "Custom",
}
